import React from 'react';
import EmployeeCars from '../../containers/Cars/EmployeeCars';

export default function EmployeeCarsPage() {
  return <EmployeeCars />;
}
